import { LocationBreadcrumbs } from "@/components/common/location-breadcrumbs";
import type { SearchHookLocation } from "@repo/maps";
import { useTranslations } from "next-intl";

export type BusinessListBreadcrumbsProps = {
  countryCode?: string;
  location?: SearchHookLocation;
  maxDepth?: number;
};

export function BusinessListBreadcrumbs({
  countryCode,
  location,
  maxDepth,
}: BusinessListBreadcrumbsProps) {
  const t = useTranslations();

  return (
    <LocationBreadcrumbs
      countryCode={countryCode}
      location={location}
      basePath="/businesses/"
      maxDepth={maxDepth}
      fallbackItem={{
        name: t("saas.search.breadcrumbs.custom"),
      }}
    />
  );
}

BusinessListBreadcrumbs.displayName = "BusinessListBreadcrumbs";
